import { useQuery } from '@tanstack/react-query'

import { ClientLocationAssociatedContactService } from '../services/client_location_associated_contacts.service'
import { APIAssociatedContactClientDtoResponse, AssociatedContactClientDto } from '../types/api'
import { defaultQueryOptions } from './common'

export const useClientLocationAssociatedContacts = (locationName: string, lupId = '') => {
  return useQuery<APIAssociatedContactClientDtoResponse>({
    queryKey: ['clientLocationAssociatedContacts', locationName, lupId],
    queryFn: () => ClientLocationAssociatedContactService.list(locationName, lupId),
    enabled: !!lupId,
    ...defaultQueryOptions,
  })
}

export const useClientLocationAssociatedContact = (locationName: string, lupId = '', contactId = '') => {
  return useQuery<AssociatedContactClientDto>({
    queryKey: ['clientLocationAssociatedContact', locationName, lupId, contactId],
    queryFn: () => ClientLocationAssociatedContactService.get(locationName, lupId, contactId),
    enabled: !!lupId,
    ...defaultQueryOptions,
  })
}
